<template>
  <b-modal
    v-model="showModal"
    :title="editId ? 'Edit Capital Supplier' : 'Add Capital Supplier'"
    size="lg"
    class="m-4"
    no-close-on-backdrop
    @hidden="$emit('modal-closed')"
    @ok="submitHandler"
  >
    <b-form
      @submit.prevent="submitHandler"
    >
      <b-row>
        <b-col cols="12">
          <b-alert
            variant="danger"
            :show="errorMessage ? true : false"
          >
            <div
              v-if="typeof errorMessage === 'string'"
              class="alert-body"
            >
              <p>
                {{ errorMessage }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.detail"
              class="alert-body"
            >
              <p>
                {{ errorMessage.detail }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.non_field_errors"
              class="alert-body"
            >
              <p>
                {{ errorMessage.non_field_errors[0] }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.message"
              class="alert-body"
            >
              <p>
                {{ errorMessage.message }}
              </p>
            </div>
          </b-alert>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Supplier Name"
            label-for="supplierName"
          >
            <b-form-input
              id="supplierName"
              v-model="name"
              type="text"
              placeholder="Enter Supplier Name"
            />
            <p
              v-if="errorMessage && errorMessage.name"
              class="error-message"
            >
              {{ errorMessage.name[0] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Address"
            label-for="address"
          >
            <b-form-input
              id="address"
              v-model="address"
              type="text"
              placeholder="Enter Address"
            />
            <p
              v-if="errorMessage && errorMessage.address"
              class="error-message"
            >
              {{ errorMessage.address[0] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="GST Applicable"
          >
            <b-form-checkbox
              v-model="gstApplicable"
              switch
            >
              {{ gstApplicable ? 'Yes' : 'No' }}
            </b-form-checkbox>
            <p
              v-if="errorMessage && errorMessage.GST_applicable"
              class="error-message"
            >
              {{ errorMessage.GST_applicable[0] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col
          v-if="gstApplicable"
          cols="6"
        >
          <b-form-group
            label="GST Number"
            label-for="gstNumber"
          >
            <b-form-input
              id="gstNumber"
              v-model="gstNumber"
              type="text"
              placeholder="Enter GST Number"
            />
            <p
              v-if="errorMessage && errorMessage.GST_number"
              class="error-message"
            >
              {{ errorMessage.GST_number[0] }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="saving"
        @click="ok()"
      >
        {{ editId ? 'Update' : 'Create' }}
        <b-spinner
          v-if="saving"
          small
          label="Small Spinner"
        />
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BButton, BFormInput, BForm, BSpinner, BAlert, BFormCheckbox,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'AddCapitalSupplier',
  components: {
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    BAlert,
    BFormCheckbox,
  },
  props: {
    editId: {
      type: [Number, String, null],
      default: null,
    },
  },
  data() {
    return {
      showModal: true,
      name: '',
      address: '',
      gstApplicable: false,
      gstNumber: '',
      saving: false,
      errorMessage: {},
    }
  },
  created() {
    if (this.editId) {
      this.fetchSupplierDetail()
    }
  },
  methods: {
    fetchSupplierDetail() {
      axios.get(`/invoices/capital_supplier/${this.editId}/`)
        .then(res => {
          const { data } = res
          this.name = data.name || ''
          this.address = data.address || ''
          this.gstApplicable = data.GST_applicable === true || data.GST_applicable === 'true'
          this.gstNumber = data.GST_number || ''
        })
        .catch(error => {
          this.errorMessage = error?.response?.data || 'Failed to load supplier details'
        })
    },
    submitHandler(event) {
      event.preventDefault()
      const formData = new FormData()
      formData.append('name', this.name)
      formData.append('address', this.address)
      formData.append('GST_applicable', this.gstApplicable)
      if (this.gstApplicable) {
        formData.append('GST_number', this.gstNumber)
      }

      this.saving = true

      const request = this.editId
        ? axios.patch(`/invoices/capital_supplier/${this.editId}/`, formData)
        : axios.post('/invoices/capital_supplier/', formData)

      request
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message || (this.editId ? 'Supplier Updated' : 'Supplier Created'),
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$emit('supplier-saved')
          this.saving = false
        })
        .catch(error => {
          this.errorMessage = error?.response?.data || 'Something went wrong'
          this.saving = false
        })
    },
  },
}
</script>

<style scoped>
.error-message {
  color: red
}
</style>
